import React from 'react';

export const Chat: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 7.52734C14 10.5533 11.3014 12.982 8.00003 12.982C7.57269 12.982 7.1567 12.94 6.75403 12.8627"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.39933 11.884C2.94667 10.8907 2 9.31601 2 7.52734"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.39938 11.8838C4.39871 12.4531 4.40004 13.2211 4.40004 14.0271"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7.52724C2 4.50124 4.69867 2.07324 8 2.07324C11.3013 2.07324 14 4.50191 14 7.52791"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75336 12.8599L4.40002 14.0265"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11781 7.54873C8.1829 7.61382 8.1829 7.71935 8.11781 7.78444C8.05272 7.84952 7.9472 7.84952 7.88211 7.78444C7.81702 7.71935 7.81702 7.61382 7.88211 7.54873C7.9472 7.48365 8.05272 7.48365 8.11781 7.54873"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7846 7.54873C10.8496 7.61382 10.8496 7.71935 10.7846 7.78444C10.7195 7.84952 10.6139 7.84952 10.5489 7.78444C10.4838 7.71935 10.4838 7.61382 10.5489 7.54873C10.6139 7.48365 10.7195 7.48365 10.7846 7.54873"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.45118 7.54873C5.51627 7.61382 5.51627 7.71935 5.45118 7.78444C5.3861 7.84952 5.28057 7.84952 5.21548 7.78444C5.15039 7.71935 5.15039 7.61382 5.21548 7.54873C5.28057 7.48365 5.3861 7.48365 5.45118 7.54873"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
